import React from "react";
import { useLocalStore, useObserver } from "mobx-react";
import { _SPORTS_WS_TOPIC } from "../../../common/constants/sportsConstants";
import { ScoreDetailService } from "../../../common/services";
import WebSocketUtil from "../../../common/utils/socketUtil";

const asyncImportModel = async (type) => {
  const model = await import(`./model/${type}`);

  return model;
};

const ScoreDetailStore = () => {
  const store = useLocalStore(() => ({
    detail: {},
    loading: false,
    init: false,
    socket: null,
    isSub: false,
    gameId: null,
    connectSocket(topic, sportsType) {
      store.socket = new WebSocketUtil(topic);

      store.socket.ws.onmessage = (event) => {
        if (event) {
          let data = event.data;

          try {
            if (data === "OK") {
              this.isSub = true;
            } else {
              let messageData = JSON.parse(data);

              if (messageData) {
                const { TOPIC, MESSAGE } = messageData;
                const data = JSON.parse(MESSAGE);

                if (!!store.gameId) {
                  _SPORTS_WS_TOPIC[sportsType].forEach((item) => {
                    if (
                      item.topic.includes("cheers") &&
                      TOPIC === `${item.topic}.${store.gameId}`
                    ) {
                      store.detail.cheerCount++;
                    } else if (TOPIC === `${item.topic}.${store.gameId}`) {
                      store.detail[item.funcName](data[item.key]);
                    }
                  });
                }
              }
            }
          } catch (error) {
            console.log("=== socket on message error ===", error);
          }
        }
      };
    },
    async getScoreDetail(sportsType, gameId) {
      store.loading = true;
      store.gameId = gameId;

      if (!store.isSub) {
        store.connectSocket(
          _SPORTS_WS_TOPIC[sportsType].map((item) => `${item.topic}.${gameId}`),
          sportsType
        );
      }

      const result = await ScoreDetailService.getSportsTypeByGameId(
        sportsType,
        gameId
      );
      // const { id } = await ScoreDetailService.getChampGameId(gameId);

      if (!!result) {
        asyncImportModel(sportsType).then((model) => {
          store.detail = new model.default(result);
          // if (!!id) {
          //   store.detail.champGameId = id;
          // }
          store.loading = false;
          store.init = true;
        });
      }
    },
  }));

  return {
    getScoreDetail: store.getScoreDetail,
    data: useObserver(() => {
      return {
        init: store.init,
        detail: store.detail,
        loading: store.loading,
      };
    }),
  };
};

export default ScoreDetailStore;
